import { render } from "./Clinic.vue?vue&type=template&id=6ba7af42"
import script from "./Clinic.vue?vue&type=script&lang=js"
export * from "./Clinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__